import gql from 'graphql-tag'

export const SubscriptionsGQL = {
    ALL_SUBSCRIPTIONS: gql`query AllSubscriptions{subscriptions{
        id
        status
        createDate
    }}`,

    SUBSCRIBE: gql`
        mutation Subscribe(
            $id: ID!
            $orderId: String!
            $facilitatorAccessToken: String!
        ){
            subscribe(
                id: $id
                orderId: $orderId
                facilitatorAccessToken: $facilitatorAccessToken
            ){id}
        }`,

    CANCEL_SUBSCRIPTION: gql`
        mutation CancelSubscription(
            $id: ID!
        ){
            cancelSubscription(id: $id){id}
        }
    `
}
